module.exports = __webpack_public_path__ + "LatoLatin-SemiboldItalic.3de9b43943b64b70f88c.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.woff
// module chunks = styles